import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-vision',
  templateUrl: './vision.component.html',
  styleUrls: ['./vision.component.scss']
})
export class VisionComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Vision');
  }

}
